var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCyber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#546e7a",
    points: "19 44 10 44 10 42 17 42 17 34 19 34 19 44"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#546e7a",
    points: "14 38 7 38 7 36 12 36 12 28.75 14 28.75 14 38"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#546e7a",
    points: "5 31 3 31 3 25 13 25 13 27 5 27 5 31"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#546e7a",
    points: "38 44 29 44 29 34 31 34 31 42 38 42 38 44"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#546e7a",
    points: "41 38 34 38 34 28 36 28 36 36 41 36 41 38"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#546e7a",
    points: "45 31 43 31 43 27 36 27 36 25 45 25 45 31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M39.989,10s.999,23-15.816,32C7.012,33,8.011,10,8.011,10,16.006,10,24,2,24,2S30.995,10,39.989,10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d4037",
    d: "M28,18a4,4,0,1,0-6.016,3.436L20,29h8l-1.984-7.564A3.98242,3.98242,0,0,0,28,18Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 37,
    r: 2,
    fill: "#4fc3f7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 31,
    r: 2,
    fill: "#4fc3f7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 43,
    r: 2,
    fill: "#4fc3f7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 37,
    r: 2,
    fill: "#4fc3f7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 31,
    r: 2,
    fill: "#4fc3f7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 43,
    r: 2,
    fill: "#4fc3f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyber);
export default __webpack_public_path__ + "static/media/cyber.844ba6e2b320e250bfe1be4e082c7d2a.svg";
export { ForwardRef as ReactComponent };